import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { of, switchMap } from 'rxjs';

import { AccountRedirectionService } from '../services/account-redirection.service';
import { TokenService } from '../services/token.service';

export const questionnaireGuard: CanActivateFn = () => {
  const _tokenService = inject(TokenService);
  const _accountRedirectionService = inject(AccountRedirectionService);

  return _tokenService.hasTokens$().pipe(
    switchMap((x) => {
      if (x) {
        return _accountRedirectionService.getStatus();
      }
      return of(true);
    }),
  );
};
